import TSXComponent from '@/utils/tsx-component';
import Component from 'vue-class-component';
import { Form, RadioGroup, ActionBar, Input, Toast } from '@ohu-mobile/core';
import FormItem from '@/components/form-item';
import { ArrowDownSFilled } from '@ohu-mobile/icons';
import { PageStatus } from '@/components/page-view';
import * as yup from 'yup';
import { AsyncSelect } from '@/components/async-select';
import AdvertCarousel from '@/components/advert/carousel';
import { CommonModule } from '../../../store/modules/common';
import SearchTip from '../../../components/advert/search-tip';

@Component({ name: 'PreEnrol' })
export default class PreEnrol extends TSXComponent {
  public mounted() {
    this.$emit(PageStatus.SUCCESS);
  }
  public render() {
    return (
      <div class="pre-enrol">
        <AdvertCarousel
          random
          areaCode="浙江"
          moduleCode="高职提前招生"
          showAreaCode="C10"/>
        <Form inline={false}
          initialValues={{ examineeType: '', queryValue: '', queryValue2: '' }}
          validateSchema={{
            examineeType: yup.string().required('考生类别是必填的'),
          }}
          scopedSlots={{
            default: ({ validate }) => {
              return (
                <div class="pre-enrol__content form-content">
                  <FormItem required title="考生类别" tip="（必选）">
                    <Form.Field name="examineeType">
                      <RadioGroup options={[
                        { label: '普招考生', value: '1' },
                        { label: '单考单招考生', value: '2' },
                      ]} />
                    </Form.Field>
                  </FormItem>
                  <div class="form-padding"></div>
                  <FormItem title="请输入院校/专业" tip="（至少选一项）">
                    <Form.Field name="academyId">
                      <AsyncSelect
                        title="选择报考科类" placeholder="选择提前招生院校" icon={ArrowDownSFilled}
                        maxHeight="10rem"
                        loadData={async () => {
                          const result = await CommonModule.getPreEnrolAcademyList();
                          return result.map(({ academyId, academyName }) => {
                            return {
                              label: academyName,
                              value: academyId,
                            };
                          });
                        }} />
                    </Form.Field>
                    <Form.Field name="professionName">
                      <Input placeholder="请输入专业名称" allowClear />
                    </Form.Field>
                    {/* <p slot="note">数据库收录了各类高校提前招生专业情况，具体录取细则请参考各高校招生章程，最终结果以章程为准</p> */}
                  </FormItem>
                  <SearchTip
                    areaCode="浙江"
                    moduleCode="高职提前招生"
                    showAreaCode="C33" />
                  <ActionBar
                    onClick={async () => {
                      try {
                        const model: any = await validate();
                        if (!model.academyId && !model.professionName) {
                          Toast.info('院校和专业必选一项');
                          return;
                        }
                        this.$router.push({ append: true, path: 'list', query: model });
                      } catch (error) {
                      }
                    }}
                    actions={[
                      { text: '查询', type: 'primary' },
                    ]} />
                </div>
              );
            },
          }} />
      </div>
    );
  }
}
